import { render, staticRenderFns } from "./workAgentAccessDialog.vue?vue&type=template&id=4e32b032&scoped=true&lang=pug"
import script from "./workAgentAccessDialog.vue?vue&type=script&lang=js"
export * from "./workAgentAccessDialog.vue?vue&type=script&lang=js"
import style0 from "./workAgentAccessDialog.vue?vue&type=style&index=0&id=4e32b032&prod&scoped=true&lang=css"
import style1 from "./workAgentAccessDialog.vue?vue&type=style&index=1&id=4e32b032&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e32b032",
  null
  
)

export default component.exports